/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.uncheckedIcon = exports.indeterminateIcon = exports.checkedIcon = void 0;
var _react = _interopRequireDefault(require("react"));
var checkedIcon = function checkedIcon(_ref) {
  var style = _ref.style,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 16 : _ref$size,
    className = _ref.className;
  return _react.default.createElement("svg", {
    width: size,
    height: size,
    style: style,
    className: className,
    viewBox: "0 0 16 16"
  }, _react.default.createElement("g", {
    fillRule: "evenodd"
  }, _react.default.createElement("rect", {
    width: size,
    height: size,
    stroke: "none",
    rx: "1"
  }), _react.default.createElement("path", {
    fill: "none",
    strokeLinecap: "round",
    strokeWidth: "2",
    d: "M3.357 9.018L7.229 12 12.613 5"
  })));
};
exports.checkedIcon = checkedIcon;
var uncheckedIcon = function uncheckedIcon(_ref2) {
  var style = _ref2.style,
    _ref2$size = _ref2.size,
    size = _ref2$size === void 0 ? 16 : _ref2$size,
    className = _ref2.className;
  return _react.default.createElement("svg", {
    width: size,
    height: size,
    className: className,
    style: style,
    viewBox: "0 0 16 16"
  }, _react.default.createElement("rect", {
    width: size - 2,
    height: size - 2,
    x: "1",
    y: "1",
    fill: "none",
    fillRule: "evenodd",
    strokeWidth: "2",
    rx: "1"
  }));
};
exports.uncheckedIcon = uncheckedIcon;
var indeterminateIcon = function indeterminateIcon(_ref3) {
  var style = _ref3.style,
    _ref3$size = _ref3.size,
    size = _ref3$size === void 0 ? 16 : _ref3$size,
    className = _ref3.className;
  return _react.default.createElement("svg", {
    width: size,
    height: size,
    style: style,
    className: className,
    viewBox: "0 0 16 16"
  }, _react.default.createElement("g", {
    fillRule: "evenodd"
  }, _react.default.createElement("g", null, _react.default.createElement("rect", {
    width: size,
    height: size,
    fill: "none",
    rx: "1"
  })), _react.default.createElement("g", null, _react.default.createElement("rect", {
    width: "10",
    height: "2",
    x: "3",
    y: "7",
    rx: "1"
  }))));
};
exports.indeterminateIcon = indeterminateIcon;